import { useStore } from 'hooks/useStore';

export const useScheduleCalculation = () => {
  const { scheduleCalculationsStore } = useStore();

  // Format duration (minutes) for display
  const formatDuration = (minutes: number | undefined | null): string => {
    if (minutes === undefined || minutes === null) {
      return '-';
    }
    return `${minutes}`;
  };

  // Update a schedule calculation
  const updateScheduleCalculation = async (scheduleCalcId: number, data: any) => {
    try {
      await scheduleCalculationsStore.updateScheduleCalculation(scheduleCalcId, data);
      return true;
    } catch (error) {
      return false;
    }
  };

  return {
    formatDuration,
    updateScheduleCalculation,
    isLoading: scheduleCalculationsStore.isLoading
  };
};

export default useScheduleCalculation;
